import { IonSearchbar, IonButton, IonIcon } from '@ionic/react';
import { filterOutline, searchOutline } from 'ionicons/icons';
import { FilterModal } from './FilterModal';
import { Box, Paper, InputAdornment, IconButton } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SearchFilters } from '../types/post';

interface SearchBarProps {
  onSearch: (filters: SearchFilters) => void;
}

export const SearchBar: React.FC<SearchBarProps> = ({ onSearch }) => {
  const { t } = useTranslation();
  const [filters, setFilters] = useState<SearchFilters>({});
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);

  const handleChange = (key: keyof SearchFilters, value: any) => {
    const newFilters = { ...filters, [key]: value };
    setFilters(newFilters);
    onSearch(newFilters);
  };

  const handleFilterApply = (newFilters: SearchFilters) => {
    setFilters(newFilters);
    onSearch(newFilters);
  };

  return (
    <Box sx={{ px: 2, mb: 3, mt: 2 }}>
      <Paper 
        elevation={2} 
        sx={{ 
          borderRadius: '20px',
          overflow: 'hidden',
          background: 'rgba(255, 255, 255, 0.85)',
          backdropFilter: 'blur(15px)',
          boxShadow: '0 8px 20px rgba(0, 0, 0, 0.05)',
          transition: 'all 0.3s cubic-bezier(0.16, 1, 0.3, 1)',
          '&:hover': {
            boxShadow: '0 12px 28px rgba(0, 0, 0, 0.08)',
            transform: 'translateY(-2px)'
          }
        }}
      >
        <Box sx={{ 
          display: 'flex', 
          gap: 1, 
          alignItems: 'center',
          p: 0.5,
          pl: 2
        }}>
          <Box sx={{ 
            flex: 1,
            display: 'flex',
            alignItems: 'center'
          }}>
            <IonIcon 
              icon={searchOutline} 
              style={{ 
                fontSize: '20px', 
                color: '#9ca3af',
                marginRight: '8px'
              }} 
            />
            {/* Temporarily replaced IonSearchbar with regular input due to initialization issues */}
            <input
              type="text"
              placeholder={t('search.placeholder')}
              onChange={(e) => handleChange('name', e.target.value)}
              style={{
                flex: 1,
                border: 'none',
                outline: 'none',
                background: 'transparent',
                fontSize: '16px',
                color: '#1f2937',
                padding: '8px 0'
              }}
            />
          </Box>
          <IconButton
            onClick={() => setIsFilterModalOpen(true)}
            sx={{
              background: 'rgba(0, 104, 185, 0.1)',
              color: '#0068B9',
              borderRadius: '12px',
              width: '40px',
              height: '40px',
              mr: 0.5,
              transition: 'all 0.3s cubic-bezier(0.16, 1, 0.3, 1)',
              '&:hover': {
                background: 'rgba(0, 104, 185, 0.15)',
                transform: 'scale(1.05)'
              }
            }}
          >
            <IonIcon icon={filterOutline} style={{ fontSize: '20px' }} />
          </IconButton>
        </Box>
      </Paper>

      <FilterModal
        isOpen={isFilterModalOpen}
        onClose={() => setIsFilterModalOpen(false)}
        onApply={handleFilterApply}
        currentFilters={filters}
      />
    </Box>
  );
};
